import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    value: 0,
}

export const historyTableDatas = createSlice({
    name: 'historyTableDatas',
    initialState,
    reducers: {
        addTableData2: (state, action) => {
            state.value = (action.payload);
        },
    },
})

// Action creators are generated for each case reducer function
export const { addTableData2 } = historyTableDatas.actions

export default historyTableDatas.reducer